import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Section from '../components/layout/Section';
import SafeIcon from '../common/SafeIcon';

export default function CaseStudiesPage() {
  const showUnverifiedExamples = false;
  const studies = [
    {
      id: 'matt',
      name: "Matt's Aberdeen Tree Service",
      reviews: '300+',
      rating: '4.8★',
      description: "How an established local trade business used RepUpgrade to turn scattered customer feedback into inescapable local gravity.",
      outcomes: ['Fast Response', 'Clean Work', 'Fair Pricing']
    },
    {
      id: 'roma',
      name: 'Roma Ristorante Italiano',
      reviews: '150+',
      rating: '4.9★',
      description: "Engineering the 'Acoustic Authority' of fine dining by automating high-fidelity service responses and social proof.",
      outcomes: ['Authentic Flavor', 'Exceptional Service', 'Great Atmosphere']
    }
  ];

  return (
    <div className="min-h-screen bg-[#F7F8F7]">
      <Navbar />
      <main className="pt-24">
        <Section className="py-20">
          <div className="max-w-6xl mx-auto px-6">
            <Link to="/home" className="text-[#409FA1] font-medium flex items-center gap-2 mb-8 hover:underline">
              <SafeIcon name="ArrowLeft" className="w-4 h-4" /> Back to Home
            </Link>
            
            <div className="space-y-6 mb-16">
              <span className="text-xs font-microma font-bold tracking-widest text-[#409FA1] uppercase">
                Local Authority Case Studies
              </span>
              <h1 className="text-5xl font-bold text-[#101F1F]">Our Success Stories</h1>
              <p className="text-xl text-[#101F1F]/70 max-w-3xl">
                Verified customer stories will be published only after the
                supporting evidence and publication permission are approved.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {showUnverifiedExamples && studies.map((study) => (
                <div key={study.id} className="bg-white rounded-3xl border border-gray-100 shadow-xl overflow-hidden flex flex-col">
                  <div className="p-8 space-y-6 flex-grow">
                    <div className="flex justify-between items-start">
                      <h3 className="text-2xl font-bold text-[#244A49]">{study.name}</h3>
                      <div className="flex gap-3">
                         <div className="text-right">
                           <div className="text-lg font-bold text-[#101F1F]">{study.reviews}</div>
                           <div className="text-[10px] text-gray-400 uppercase">Reviews</div>
                         </div>
                         <div className="text-right">
                           <div className="text-lg font-bold text-[#101F1F]">{study.rating}</div>
                           <div className="text-[10px] text-gray-400 uppercase">Rating</div>
                         </div>
                      </div>
                    </div>
                    <p className="text-gray-600">{study.description}</p>
                    <div className="flex flex-wrap gap-2">
                      {study.outcomes.map(tag => (
                        <span key={tag} className="text-[10px] font-bold bg-[#F7F8F7] text-[#409FA1] px-3 py-1 rounded-full border border-gray-100">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="bg-gray-50 p-6 border-t border-gray-100">
                    <Link to="/start" className="text-[#2CB5B0] font-bold text-sm flex items-center gap-2 hover:underline">
                      Start Your Case Study <SafeIcon name="ArrowRight" className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              ))}

              <div className="bg-white rounded-3xl border border-gray-100 shadow-xl overflow-hidden flex flex-col md:col-span-2">
                <div className="p-8 space-y-6 text-center sm:p-12">
                  <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#409FA1]/10 text-[#409FA1]">
                    <SafeIcon name="FileCheck" className="h-6 w-6" />
                  </span>
                  <h2 className="text-2xl font-bold text-[#244A49]">
                    Verified case studies coming soon.
                  </h2>
                  <p className="mx-auto max-w-2xl text-gray-600">
                    Customer identities, ratings, review counts, and outcomes
                    will appear here only after verification and publication
                    permission.
                  </p>
                </div>
                <div className="bg-gray-50 p-6 border-t border-gray-100 text-center">
                  <Link to="/playground" className="text-[#2CB5B0] font-bold text-sm inline-flex items-center gap-2 hover:underline">
                    Explore the Product Preview <SafeIcon name="ArrowRight" className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="mt-20 p-12 bg-[#101F1F] rounded-3xl text-center space-y-8">
              <h2 className="text-3xl font-bold text-white">Ready to build your local authority?</h2>
              <p className="text-white/60 max-w-lg mx-auto">
                Join Joseph in the Studio for a personalized authority audit of your business reputation.
              </p>
              <Link 
                to="/start"
                className="inline-flex items-center gap-3 bg-[#F49558] hover:bg-[#D35E0E] text-white font-bold py-4 px-10 rounded-xl shadow-lg shadow-[#F49558]/20 transition-all hover:-translate-y-1"
              >
                Start My Setup <SafeIcon name="ArrowRight" />
              </Link>
            </div>
          </div>
        </Section>
      </main>
      <Footer />
    </div>
  );
}